export default __webpack_public_path__ + "static/media/SharnaLovelace.97e6cf6a.png";